import { colorCode, safetyPercentage } from "../utilities/helpers"
import { FLAGS_API_URL } from "../const/paths"
import CardSummary from "./CardSummary"
import CardAnalysis from "./CardAnalysis"
import RiskProfileColors from "./RiskProfileColors"

export default function PlaceCard({
    place,
    currentLocation,
    showAnalysis,
    mainCard,
    version,
    // Stretches the card to match a taller sibling in an equal-height card
    // grid (see the "In the spotlight" row in routes/index.jsx). Turn this
    // off for a card placed alone or beside unrelated content -- forcing it
    // to match, say, a much taller sidebar just leaves dead space inside it.
    equalHeight = true,
}) {
    let placePhoto = null
    placePhoto = Array.isArray(place?.fromGoogle?.photos)
        ? place.fromGoogle.photos[0] ?? null
        : null

    return (
        <div
            id="safety-card-profile"
            className={`card${equalHeight ? " h-100" : ""}`}
            style={{ borderRadius: "5px 5px" }}
        >
            <div
                style={{
                    backgroundImage: `url(${FLAGS_API_URL}/${place?.country_code}.svg)`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    height: "auto",
                    minHeight: "200px",
                    borderRadius: "5px 5px 0 0",
                }}
            >
                <img
                    src={`${place?.fromGoogle?.photo_cover?.photo_ref}`}
                    className="card-img-top"
                    alt={``}
                    title={`${place?.name}`}
                />
            </div>
            <div
                className="progress"
                style={{ height: "20px", borderRadius: "0px" }}
            >
                <div
                    className={`progress-bar  ${
                        currentLocation
                            ? "progress-bar-striped progress-bar-animated"
                            : ""
                    } bg-${colorCode(safetyPercentage(place?.overall_safety))}`}
                    role="progressbar"
                    aria-valuenow={
                        100 - safetyPercentage(place?.overall_safety)
                    }
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style={{
                        width: `${safetyPercentage(place?.overall_safety)}%`,
                    }}
                >
                    <b>SAFETY: {safetyPercentage(place?.overall_safety)}%</b>
                </div>
            </div>
            {/* Grows to absorb any extra height from the card's own h-100
                (e.g. matching a taller sidebar card), so that space lands
                here instead of stretching card-footer below its one line
                of content. */}
            <div className="flex-grow-1 position-relative mt-2">
                {/* Overlaid rather than floated: the summary below is a flex
                    container, which sits beside a float instead of under it
                    and would lose the legend's width, pushing the content
                    off-centre. */}
                <div className="position-absolute top-0 end-0">
                    <RiskProfileColors />
                </div>
                {showAnalysis ? (
                    <CardAnalysis
                        place={place}
                        currentLocation={currentLocation}
                    />
                ) : (
                    <CardSummary
                        place={place}
                        currentLocation
                        mainCard={mainCard}
                    />
                )}
            </div>
            <div className="card-footer">
                <small className="text-body-secondary">
                    <em>
                        {new Date(place?.updated_at).toLocaleDateString(
                            "en-US",
                            {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                            }
                        )}
                    </em>
                </small>
                {placePhoto && (
                    <span
                        className="small muted text-plain"
                        style={{
                            float: "right",
                            textDecoration: "none",
                            color: "#808080",
                            opacity: 0.4,
                        }}
                    >
                        photo by:&nbsp;
                        <span
                            dangerouslySetInnerHTML={{
                                __html: placePhoto?.html_attributions[0],
                            }}
                        />
                    </span>
                )}
            </div>
        </div>
    )
}
